import React from 'react';
import { Link } from 'react-router-dom';
import { Slide } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

const FeaturesSection = (props) => {
    const { t } = useTranslation();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    // Tüm metinleri anahtarlıyoruz:
    const Features = [
        {
            unit: 'culture',
            title: t('unit_culture_title'),
            des: t('unit_culture_desc'),
            icon: 'fa-solid fa-landmark',
        },
        {
            unit: 'art',
            title: t('unit_art_title'),
            des: t('unit_art_desc'),
            icon: 'fa-solid fa-palette',
        },
        {
            unit: 'sport',
            title: t('unit_sport_title'),
            des: t('unit_sport_desc'),
            icon: 'fa-solid fa-futbol',
        },
        {
            unit: 'social',
            title: t('unit_social_title'),
            des: t('unit_social_desc'),
            icon: 'fa-solid fa-hand-holding-heart',
        },
        {
            unit: 'international',
            title: t('unit_international_title'),
            des: t('unit_international_desc'),
            icon: 'fa-solid fa-globe',
        },
    ];

    return (
        <div className="featureArea pt-70">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <h2 className="sectionTitle__big">{t("organization_title")}</h2>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {Features.slice(0, 3).map((feature, index) => (
                        <div className="col-lg-4 col-md-6 mb-4" key={index}>
                            <Slide direction='up' triggerOnce={'false'}>
                                <div className="keyFeatureBlock text-center">
                                    <div className="keyFeatureBlock__left mb-3">
                                        <span className="keyFeatureBlock__icon">
                                            <i className={`${feature.icon} organizationUnitIcon`} aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div className="keyFeatureBlock__content">
                                        <h3 className="keyFeatureBlock__heading">
                                            <Link onClick={ClickHandler} className="keyFeatureBlock__heading__link" to={`/blog?unit=${feature.unit}`}>
                                                {feature.title}
                                            </Link>
                                        </h3>
                                        <p className="keyFeatureBlock__text">{feature.des}</p>
                                    </div>
                                </div>
                            </Slide>
                        </div>
                    ))}
                </div>
                <div className="row justify-content-center">
                    {Features.slice(3).map((feature, index) => (
                        <div className="col-lg-6 col-md-6 mb-4" key={index + 3}>
                            <Slide direction='up' triggerOnce={'false'}>
                                <div className="keyFeatureBlock text-center">
                                    <div className="keyFeatureBlock__left mb-3">
                                        <span className="keyFeatureBlock__icon">
                                            <i className={`${feature.icon} organizationUnitIcon`} aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div className="keyFeatureBlock__content">
                                        <h3 className="keyFeatureBlock__heading">
                                            <Link onClick={ClickHandler} className="keyFeatureBlock__heading__link" to={`/blog?unit=${feature.unit}`}>
                                                {feature.title}
                                            </Link>
                                        </h3>
                                        <p className="keyFeatureBlock__text">{feature.des}</p>
                                    </div>
                                </div>
                            </Slide>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeaturesSection;
